(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('promiseUtilityService', promiseUtilityService);

	function promiseUtilityService($q, $timeout, _) {
		function fromResult(result) {
			var deferred = $q.defer();
			deferred.resolve(result);
			return deferred.promise;
		}

		function rejectWith(result) {
			var deferred = $q.defer();
			deferred.reject(result);
			return deferred.promise;
		}

		function forEachAsync(collection, callback, cancellationToken) {
			collection = _.toArray(collection);
			var deferred = $q.defer();
			var timer;
			var index = 0;

			if (cancellationToken) {
				cancellationToken.whenCanceled(function () {
					$timeout.cancel(timer);
					deferred.reject();
				});
			}

			function processItemSoon() {
				timer = $timeout(processItem, 0, false);
			}

			function processItem() {
				if (!collection.length) {
					deferred.resolve();
					return;
				}

				if (callback(collection.pop(), index++) === false)
					deferred.resolve();
				else
					processItemSoon();
			}

			processItemSoon();
			return deferred.promise;
		}

		function parallelForEach(source, parallelOptions, callback) {
			var deferred = $q.defer();
			var promises = [];

			function continueWork(count) {
				if (!source.length) {
					$q.all(promises)
						.then(function (result) {
							deferred.resolve(result);
						})
						.catch(function (reason) {
							deferred.reject(reason);
						});

					return;
				}

				if (parallelOptions.cancellationToken && parallelOptions.cancellationToken.isCancelled) {
					deferred.reject('cancelled');
					return;
				}

				_.first(source, count).forEach(function (f) {
					promises.push(
						$q.when(callback(f))
							.finally(function () {
								continueWork(1);
							}));
				});

				source = _.drop(source, count);
			}

			continueWork(parallelOptions.maxDegreeOfParallelism);

			return deferred.promise;
		}

		function any(promises) {
			promises = _.compact(_.isArray(promises) ? promises : _.toArray(arguments));
			if (!promises.length)
				return fromResult(null);

			var deferred = $q.defer();

			promises.forEach(function(promise) {
				promise.then(deferred.resolve);
			});

			return deferred.promise;
		}

		return {
			fromResult: fromResult,
			rejectWith: rejectWith,
			forEachAsync: forEachAsync,
			parallelForEach: parallelForEach,
			any: any
		};
	}
	promiseUtilityService.$inject = ['$q', '$timeout', '_'];
})();